import type * as Blockly from 'blockly/core';
import { resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { registerOledInit } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/helper/oled_init';
import { markOledUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/oled_print';

export function register(gen: any): void {
    gen.forBlock['oled_clear'] = function (block: Blockly.Block): string {
        markOledUsed();

        const board = resolveBoard(block);
        const position = block.getFieldValue('POSITION') ?? 'UPPER_LEFT';

        registerOledInit(board, position);

        return `oled.clearDisplay();\noled.display();\n`;
    };
}
